import React, { useEffect } from "react";
import { Box, Button, lighten, Typography, useTheme } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import { styles } from "../../../../assets/MUIStyles/agentStyle";

const AgentSelect = ({ agent, handleChange }) => {
  const theme = useTheme();
  const brandColor = theme.custom.brandColor;
  const { agentType } = agent;

  useEffect(() => {
    handleTypeSelection(agentType);
  }, [agentType]);

  const handleTypeSelection = (type) => {
    handleChange({ target: { name: "agentType", value: type } });
  };

  return (
    <Box
      className="flex-row-center"
      sx={{
        mb: 4,
        gap: 4,
        textAlign: "center",
      }}
    >
      <Button
        variant="contained"
        sx={styles.buttonStyles("call", agentType, brandColor)}
        onClick={() => handleTypeSelection("call")}
      >
        <CallIcon fontSize="large" />
        <Typography sx={styles.font_14_capital}>Call Agent</Typography>
      </Button>
      <Button
        variant="contained"
        sx={styles.buttonStyles("email", agentType, brandColor)}
        onClick={() => handleTypeSelection("email")}
      >
        <EmailIcon fontSize="large" />
        <Typography sx={styles.font_14_capital}>Email Agent</Typography>
      </Button>
      <Button
        variant="contained"
        sx={styles.buttonStyles("sms", agentType, brandColor)}
        onClick={() => handleTypeSelection("sms")}
      >
        <SmsIcon fontSize="large" />
        <Typography sx={styles.font_14_capital}>SMS Agent</Typography>
      </Button>
    </Box>
  );
};

export default AgentSelect;
